/* eslint-disable no-undef */
import { useEffect, useState } from 'react';
import uniqid from 'uniqid';

import PasswordInput from 'global/CustomInput/password';

interface PasswordFieldProps {
  onChange: (val: string) => void;
  value?: string;
  isError?: boolean;
}

function PasswordField({ onChange, isError, value }: PasswordFieldProps) {
  const [val, setVal] = useState('');

  const fieldId = uniqid('pw-');

  const handleChange = (e) => {
    const { value } = e.target;

    setVal(value);
    onChange(value);
  };

  useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <PasswordInput
      name={fieldId}
      id={fieldId}
      error={isError}
      // type={"password"}
      value={val}
      onChange={handleChange}
      required
      width="100%"
      autoComplete="new-password"
      data-cy="verify-password-input-box"
    />
  );
}

export default PasswordField;
